import { Routes } from "../Shared/components/Navigation/navigationUtils";
// TODO! @MUI INCORPORATE INTO THEME
export const routesThatUseBgColor = [
    { path: Routes.SKU },
    { path: Routes.ORDER_FLOW },
    { path: Routes.EDIT_FLOW },
    { path: Routes.LOGIN },
    { path: Routes.REGISTER },
    { path: Routes.INDEX },
    { path: Routes.CHECKOUT },
    { path: Routes.THANK_YOU },
    { path: Routes.NOT_FOUND },
];
export const routesThatHideHeader = [{ path: Routes.LOGIN }, { path: Routes.REGISTER }, { path: Routes.INDEX }];
//If we are in the SFF mobile app we remove the headers and footers from Location, Order Flow, Checkout and Thank you pages.
export const sffMobileRoutes = [
    { path: Routes.SKU },
    { path: Routes.ORDER_FLOW },
    { path: Routes.EDIT_FLOW },
    { path: Routes.CHECKOUT },
    { path: Routes.THANK_YOU },
];
export const notFoundRoutes = [{ path: Routes.NOT_FOUND }];
